<Modal title="Submit a request for this offer" actionTitle="Submit" isWide={true} {isLoading} on:close={() => $uiState.activeModal = undefined} on:action={() => apply('new')}>
  <article class="message is-info">
    <div class="message-body">
      <p class="block">It helps to add a note to your request, here are some ideas.</p>
      
      <p class="block">
        <b>How would your charity would use the items?</b><br/>
        Give a short explanation of how you would use the items.
      </p>
      
      {#if item.data.options?.divisible}
      <p class="block">
        <b>What quantity do you need?</b><br/>
        The business is willing to split this offer across multiple charities. Please state what quantity you are requesting.
      </p>
      {/if}

      {#if !item.data.options?.nationwide}
      <p class="block">
        <b>How would you collect the items?</b><br/>
        Unless the business is offering to deliver, you will be expected to collect the items. It helps to:<br/>
        - confirm that you can collect the items<br/>
        - explain what flexibility you have (how soon and what days/hours)<br/>
        - if it is a large offer, explain if you have appropriate transport and whether you would need any help<br/>
      </p>

      {/if}

    </div>
  </article>
  {#if !item.data.options?.nationwide && distance >= 10}
    <article class="message is-warning">
      <div class="message-body">
        <p class="block">This offer is {distance} miles away from your charity location</p>
        <p class="block">Please check the offer details regarding collection and delivery.</p>
      </div>
    </article>
  {/if}
  <div class="field">
    <div class="field-body">
      <div class="field">
        <div class="control">
          <textarea
            class="textarea"
            placeholder="Add a note"
            rows="10"
            bind:value={message} />
        </div>
      </div>
    </div>
  </div>
</Modal>

<script lang="ts">
  export let item : PublishedOffer_v1_Doc;
  export let distance: number;

  import { uiState } from '../../../../lib/uiState';
  import Modal from 'components/Modal.svelte';

  let message : string;

  let isLoading = false;

  async function apply(status: RequestStatus) {

    isLoading = true;

    let firebase = window.firebase;

    await firebase.functions().httpsCallable('api-request-createrequest')({offerId: item.id, message, status} as CreateRequestParams);

    isLoading = false;

    $uiState.activeModal = undefined;
  }

</script>